(function () {
	"use strict";

	angular.module("swurveys.maker")
		.factory("shareModal", Handler)

	function Handler(ModalService, $timeout, utilsService) {

		function show(swurvey) {
			return ModalService.showModal({
					templateUrl: "app/modals/swurvey/share/share.html",
					controller: ['$element', 'close', function ($element, close) {

						var modal = this;

            modal.swurvey = swurvey;
						modal.opengraphUserTokenTemplate = utilsService.getOpenGraphLink(swurvey.id,"{TOKEN}");

						modal.close = function () {
							close(null, 500);
						};
					}],
					controllerAs: "modal"
				});
		}

		return {
			show: show
		};
	}
}());
